import { lazy } from 'react-loosely-lazy';

export const RenotifyModal = lazy(
	() =>
		// eslint-disable-next-line import/dynamic-import-chunkname
		import(/* webpackChunkName: "async-people-menu-renotify-modal" */ './RenotifyModal'),
);
